(function () {
  'use strict';

  var STORAGE_KEY = 'tam_skin_quiz_dismissed_at';
  var COMPLETED_KEY = 'tam_skin_quiz_completed';
  var KLAVIYO_PUBLIC_KEY = 'XqWfnX';

  var root = document.getElementById('skin-quiz-popup');
  if (!root) return;

  var scrollTriggerPercent = parseInt(root.dataset.scrollTrigger, 10) || 40;
  var dwellTriggerSeconds = parseInt(root.dataset.dwellTrigger, 10) || 8;
  var suppressDays = parseInt(root.dataset.cooldownDays, 10) || 7;
  var listId = root.dataset.klaviyoListId || 'SqVScQ';
  var discountCode = root.dataset.discountCode || 'SKINQUIZ15';

  var chosenConcern = null;
  var chosenCollectionHandle = null;

  function alreadyCompleted() {
    try {
      return localStorage.getItem(COMPLETED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function isSuppressed() {
    try {
      var dismissedAt = localStorage.getItem(STORAGE_KEY);
      if (!dismissedAt) return false;
      var elapsedDays = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
      return elapsedDays < suppressDays;
    } catch (e) {
      return false;
    }
  }

  function suppress() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
  }

  function markCompleted() {
    try {
      localStorage.setItem(COMPLETED_KEY, '1');
    } catch (e) {
      /* ignore */
    }
  }

  function openPopup() {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    suppress();
  }

  function showStep(name) {
    var steps = root.querySelectorAll('.skin-quiz-step');
    for (var i = 0; i < steps.length; i++) {
      steps[i].hidden = steps[i].getAttribute('data-step') !== name;
    }
  }

  // ---- Trigger logic: scroll depth OR dwell time, whichever fires first ----
  function initTrigger() {
    if (alreadyCompleted() || isSuppressed()) return;

    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      window.removeEventListener('scroll', onScroll);
      clearTimeout(dwellTimer);
      openPopup();
    }

    function onScroll() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var percent = (scrollTop / docHeight) * 100;
      if (percent >= scrollTriggerPercent) fire();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    var dwellTimer = setTimeout(fire, dwellTriggerSeconds * 1000);
  }

  // ---- Step 1: concern selection -> go to email step ----
  var tiles = root.querySelectorAll('.skin-quiz-option');
  for (var t = 0; t < tiles.length; t++) {
    tiles[t].addEventListener('click', function () {
      chosenConcern = this.dataset.concern;
      chosenCollectionHandle = this.dataset.collectionHandle;
      showStep('email');
      var emailInput = document.getElementById('skin-quiz-email');
      if (emailInput) emailInput.focus();
    });
  }

  // ---- Step 2: email submit -> Klaviyo, then reveal code ----
  var emailForm = root.querySelector('[data-quiz-email-form]');
  if (emailForm) {
    emailForm.addEventListener('submit', function (evt) {
      evt.preventDefault();

      var emailInput = document.getElementById('skin-quiz-email');
      var errorEl = root.querySelector('[data-quiz-error]');
      var submitBtn = emailForm.querySelector('.skin-quiz-submit-btn');
      var btnText = emailForm.querySelector('[data-btn-text]');
      var email = emailInput.value.trim();

      errorEl.hidden = true;

      if (!email || email.indexOf('@') === -1) {
        errorEl.textContent = 'Please enter a valid email address.';
        errorEl.hidden = false;
        return;
      }

      submitBtn.disabled = true;
      if (btnText) btnText.textContent = 'Unlocking…';

      submitToKlaviyo(email, chosenConcern)
        .then(function () {
          revealUnlocked();
        })
        .catch(function () {
          // Even if Klaviyo submission fails, don't block the customer from
          // their discount code — proceed anyway.
          revealUnlocked();
        });
    });
  }

  function submitToKlaviyo(email, concern) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  skin_quiz_concern: concern,
                  skin_quiz_source: 'skin_quiz_popup',
                  skin_quiz_completed_at: new Date().toISOString()
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(payload)
    });
  }

  function revealUnlocked() {
    var codeEl = root.querySelector('[data-unlocked-code]');
    var ctaEl = root.querySelector('[data-unlocked-cta]');

    codeEl.textContent = discountCode;

    var redirectPath = chosenCollectionHandle
      ? '/collections/' + chosenCollectionHandle
      : '/collections/all';

    ctaEl.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(redirectPath);

    markCompleted();
    showStep('unlocked');
  }

  // ---- Close handlers ----
  var closeEls = root.querySelectorAll('[data-quiz-close]');
  for (var c = 0; c < closeEls.length; c++) {
    closeEls[c].addEventListener('click', closePopup);
  }

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && !root.hidden) closePopup();
  });

  initTrigger();
})();
